
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class QznnTable extends Vue {
    //抢庄牛牛
    table = {
        data: [],
        column: [
            {
                key: 'black',
                title: '变动金额',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let str = (this as any).getMoney(strzo[bulidUid(params.row.user_id, strzo)].RealAWard)
                    return h('span', str)
                }
            },
            {
                key: 'black',
                title: '税收金额',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let str = (this as any).getMoney(strzo[bulidUid(params.row.user_id, strzo)].PercentPoin)
                    return h('span', str)
                }
            },
            {
                key: 'PotPoint',
                title: '彩金奖池',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let str = (this as any).getMoney(strzo[bulidUid(params.row.user_id, strzo)].PotPoint)
                    return h('span', str)
                }
            },
            {
                key: 'black',
                title: '游戏身份',
                align: 'center',
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).banker
                    let str = String(strzo).indexOf(params.row.user_id) > -1 ? '庄家' : '闲家'
                    return h('span', str)
                }
            },
            {
                key: 'black',
                title: '庄家抢庄倍数',
                align: 'center',
                render: (h, params) => {
                    let str = JSON.parse(params.row.opt_detail).rob_multi
                    return h('span', str)
                }
            },
            {
                key: 'black',
                title: '庄家牌型',
                align: 'center',
                width: 200,
                render: (h, params) => {
                    let strzo = JSON.parse(params.row.opt_detail).users
                    let userid = JSON.parse(params.row.opt_detail).banker
                    let str = strzo[String(userid)]
                    return h('div', {
                        style: {
                            marginTop: '5PX'
                        },
                        domProps: {
                            innerHTML: str.C.map((x) => {
                                return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                            })
                        }
                    })
                }
            }
        ],
        columns1: [
            {
                key: 'game_name',
                title: '闲家1',
                align: 'center',
                render: (h, params) => {
                    let banker = JSON.parse(params.row.opt_detail).banker
                    let strzo = JSON.parse(params.row.opt_detail).users
                    delete strzo[banker]
                    let obj = Reflect.ownKeys(strzo)
                    if (obj.length > 0) {
                        let str = strzo[String(obj[0])].C
                        return h('div', [
                            h('p', { style: { color: 'blue', marginTop: '2px' } }, obj[0] == bulidUid(params.row.user_id, strzo) ? `${bulidUid(obj[0])}(查询玩家)` : bulidUid(obj[0])),
                            h('div', {
                                style: { marginTop: '5px', position: 'relative', height: '50px' },
                                domProps: {
                                    innerHTML: str.map((x, index) => {
                                        return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                    })
                                }
                            }),
                            h('p', { style: { color: 'red', marginTop: '2px' } }, strzo[String(obj[0])].Bet == -1 ? '' : `下注倍数${strzo[String(obj[0])].Bet}`)
                        ])
                    } else {
                        return h('span', '无')
                    }
                }
            },
            {
                key: 'game_name',
                title: '闲家2',
                align: 'center',
                render: (h, params) => {
                    let banker = JSON.parse(params.row.opt_detail).banker
                    let strzo = JSON.parse(params.row.opt_detail).users
                    delete strzo[banker]
                    let obj = Reflect.ownKeys(strzo)
                    if (obj.length > 1) {
                        let str = strzo[String(obj[1])].C
                        return h('div', [
                            h('p', { style: { color: 'blue', marginTop: '2px' } }, obj[1] == bulidUid(params.row.user_id, strzo) ? `${bulidUid(obj[1])}(查询玩家)` : bulidUid(obj[1])),
                            h('div', {
                                style: { marginTop: '5px', position: 'relative', height: '50px' },
                                domProps: {
                                    innerHTML: str.map((x, index) => {
                                        return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                    })
                                }
                            }),
                            h('p', { style: { color: 'red', marginTop: '2px' } }, strzo[String(obj[1])].Bet == -1 ? '' : `下注倍数${strzo[String(obj[1])].Bet}`)
                        ])
                    } else {
                        return h('span', '无')
                    }
                }
            },
            {
                key: 'game_name',
                title: '闲家3',
                align: 'center',
                render: (h, params) => {
                    let banker = JSON.parse(params.row.opt_detail).banker
                    let strzo = JSON.parse(params.row.opt_detail).users
                    delete strzo[banker]
                    let obj = Reflect.ownKeys(strzo)
                    if (obj.length > 2) {
                        let str = strzo[String(obj[2])].C
                        return h('div', [
                            h('p', { style: { color: 'blue', marginTop: '2px' } }, obj[2] == bulidUid(params.row.user_id, strzo) ? `${bulidUid(obj[2])}(查询玩家)` : bulidUid(obj[2])),
                            h('div', {
                                style: { marginTop: '5px', position: 'relative', height: '50px' },
                                domProps: {
                                    innerHTML: str.map((x, index) => {
                                        return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                    })
                                }
                            }),
                            h('p', { style: { color: 'red', marginTop: '2px' } }, strzo[String(obj[2])].Bet == -1 ? '' : `倍数${strzo[String(obj[2])].Bet}`),
                            ,
                        ])
                    } else {
                        return h('span', '无')
                    }
                }
            },
            {
                key: 'game_name',
                title: '闲家4',
                align: 'center',
                render: (h, params) => {
                    let banker = JSON.parse(params.row.opt_detail).banker
                    let strzo = JSON.parse(params.row.opt_detail).users
                    delete strzo[banker]
                    let obj = Reflect.ownKeys(strzo)
                    if (obj.length > 3) {
                        let str = strzo[String(obj[3])].C
                        return h('div', [
                            h('p', { style: { color: 'blue', marginTop: '2px' } }, obj[3] == bulidUid(params.row.user_id, strzo) ? `${bulidUid(obj[3])}(查询玩家)` : bulidUid(obj[3])),
                            h('div', {
                                style: { marginTop: '5px', position: 'relative', height: '50px' },
                                domProps: {
                                    innerHTML: str.map((x, index) => {
                                        return "<img style='width:35px;' src=img/poker/" + x + '.png>'
                                    })
                                }
                            }),
                            h('p', { style: { color: 'red', marginTop: '2px' } }, strzo[String(obj[3])].Bet == -1 ? '' : `下注倍数${strzo[String(obj[3])].Bet}`)
                        ])
                    } else {
                        return h('span', '无')
                    }
                }
            }
        ]
    }

    @Prop()
    listdata
}
